import { useLoginAlert } from 'context/LoginAlertProvider'
import styled, { css } from 'styled-components'
import { useGqlRelatedCompaniesQuery } from 'generated/graphql'
import CompanyInfoCardVertical from '@app.feature/companyInfo/main/desktop/components/CompanyInfoCardVertical'
import formatCompanyInfoCardData from '@app.feature/companyInfo/main/utils/formatCompanyInfoCardData'

const DetailOverviewRelated = ({ companyId }: { companyId: string }) => {
  const { checkLogin } = useLoginAlert()

  const { data } = useGqlRelatedCompaniesQuery({
    variables: {
      companyId,
    },
    fetchPolicy: 'cache-first',
  })

  const relatedCompanies = data?.relatedCompanies || []
  const relatedCompaniesData = formatCompanyInfoCardData(relatedCompanies)

  return (
    <StyledWrapper>
      <header>
        <h2>이 기업 조회자가 많이 본 기업</h2>
      </header>
      <ul className="related-list">
        {relatedCompaniesData.map((item) => (
          <li key={item.companyInformationId}>
            <CompanyInfoCardVertical
              data={item}
              checkLogin={checkLogin}
              relatedCompanyId={companyId}
            />
          </li>
        ))}
      </ul>
    </StyledWrapper>
  )
}

export default DetailOverviewRelated

const StyledWrapper = styled.section`
  ${({ theme }) => css`
    margin-top: 28px;

    width: 1100px;
    background-color: ${theme.background.bg_8};
    padding: 32px;
    border-radius: 8px;
    border: 1px solid ${theme.line.line_3};

    > header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;

      > h2 {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        margin: 0;
      }
    }
    .related-list {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 20px;
    }
  `}
`
